import Flex from 'UIKit/Box/Flex'
import EmptyContent from 'UIKit/EmptyContent'
import HunnyList from 'UIKit/HunnyList'
import { APIEndpointEnum } from 'config/constants/server'
import { useCallback } from 'react'
import PaymentService from 'services/PaymentService'
import { useAuth } from 'state/auth/hooks'
import { PaymentTransactionFilters } from '../../types'
import DownloadButton from '../DownloadButton'
import { useHideButtonDownLoad } from '../hook'
import DepositTransactionListITem, { DepositTransactionListLoader } from './DepositTransactionListItem'

const LazyHistoryItem = ({ item }) => <DepositTransactionListITem transaction={item} />

const DepositTransactionList: React.FC<{ filters: PaymentTransactionFilters }> = ({ filters }) => {
  const { hasSession, isSigned } = useAuth()
  const { refDownloadButton, handleHideButtonDownload } = useHideButtonDownLoad()

  const request = useCallback(
    (offset: number, limit: number) => {
      handleHideButtonDownload(true)
      return PaymentService.getDeposits(offset, limit, filters)
    },
    [filters],
  )

  return hasSession ? (
  <Flex flexDirection="column" className="hunny-lazy-list">
      <HunnyList
        processContent="You've viewed {{count}} of {{total}} transactions"
        Item={LazyHistoryItem}
        onCountChanged={(count) => {
          if (!count) handleHideButtonDownload(true)
          else handleHideButtonDownload(false)
        }}
        listName="deposit-list"
        Loader={
          <>
            <DepositTransactionListLoader />
            <DepositTransactionListLoader />
            <DepositTransactionListLoader />
            <DepositTransactionListLoader />
            <DepositTransactionListLoader />
            <DepositTransactionListLoader />
          </>
        }
        request={isSigned ? request : null}
        limit={12}
        noContent={
          <EmptyContent
            width="100%"
            height="100%"
            alignItems="center"
            justifyContent="center"
            content="No transaction to show"
          />
        }
      />

      <Flex
        style={{
          display: 'none',
        }}
        ref={refDownloadButton}
        width="100%"
        my="24px"
        justifyContent="flex-end"
      >
        <DownloadButton api={APIEndpointEnum.ExportDepositHistory} filters={filters} />
      </Flex>
    </Flex>
  ) : (
    <EmptyContent justifyContent="center" content="No transaction to show" />
  )
}

export default DepositTransactionList
